<template>
  <div>
    <component :is="componentName" v-model="Modal" :index="index" @close="close" @add="add" @change="change"></component>
  </div>
</template>

<script>
import customProductType1 from "@components/custom-component/common/custom-product/components/custom-product-type-1.vue";
export default {
  // 产品分组类型 1
  name: "custom-product",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function() {
        return {
          type: 1,
          Name: "", // 分组名称
          ShowGroupName: 1, // 显示分组名称
          FirstPriority: 0, // 第一显示优先级
          SecondPriority: 0, // 第二显示优先级
          ListStyle: 0, // 列表样式
          ShowProductName: 1, // 显示产品的名称
          ShowProductPrice: 1, // 显示产品的价格
          Introduction: "" // 分组的描述
        };
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    componentName() {
      return `customProductType${this.Modal.type}`;
    }
  },
  components: {
    customProductType1
  },
  methods: {
    close() {
      this.$emit("close");
    },
    add(item, idx) {
      this.$emit("add", item, idx);
    },
    change(req) { 
      this.$emit("sendModal", req);
    }
  }
};
</script>

<style scoped lang="scss">
</style>
